"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var types_1 = require("./types");
function gameInit(armies) {
    return {
        armies: armies,
        type: types_1.GAME_INIT
    };
}
exports.gameInit = gameInit;
function gameTileDrop(col, row, tile) {
    return {
        col: col,
        row: row,
        tile: tile,
        type: types_1.GAME_TILE_DROP
    };
}
exports.gameTileDrop = gameTileDrop;
